export default __webpack_public_path__ + "images/onboarding/sitara-480178ff82313a355b2d04e46e3ebf16.svg";